import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PublisherUserAuthComponent } from './auth.component';

const routes: Routes = [
    { path: '', component: PublisherUserAuthComponent },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class PublisherUserAuthRoutingModule {
}


// WEBPACK FOOTER //
// /Users/creative/Documents/GitHub/makrooreservation/src/ui/src/app/auth/publisher-user/auth-routing.routing.ts